exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gallery__preview[data-v-eb261910] {\n  min-width: 100%;\n  height: 150px;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image[data-v-eb261910] {\n  min-height: 100px;\n  cursor: move;\n}\n.ghost[data-v-eb261910] {\n  opacity: 0.5;\n  background: #98c000;\n}\n.img-sort-help[data-v-eb261910] {\n  font-size: 0.9rem !important;\n  color: #6d6d6d;\n}", ""]);

// exports
